export default __webpack_public_path__ + "static/media/avatar.c42fef05.png";